import { PanelGroup } from "../enums";


export function flattenMaterialMaps(materialMaps: Record<PanelGroup, string[]>[]): Record<PanelGroup, string[]> {
	return (materialMaps ?? []).reduce((acc, materialMap) => {
		if (!materialMap) {
			return acc;
		}

		Object.keys(materialMap).forEach(groupKey => {
			const panelGroup = groupKey as PanelGroup;
			const materials = materialMap[panelGroup];

			if (acc[panelGroup]) {
				acc[panelGroup] = Array.from(
					new Set([
						...acc[panelGroup],
						...materials,
					])
				);
			} else {
				acc[panelGroup] = materials;
			}
		});

		return acc;
	}, {} as Record<PanelGroup, string[]>);
}
